<template>
  <div class="bg-white p-4 lg:mt-0 md:mt-0 mt-4">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <!-- <p>Category Name</p> -->
        <p>Selected Event</p>
        <b-input
          disabled
          placeholder="Enter category name"
          class="mb-4"
          v-model="album.eventName.title"
          @change="handleOnInputChange"
        />
        <!-- <b-form-select v-model="album.eventName.title" class="mb-4" disabled>
          <b-form-select-option :value="null">Select</b-form-select-option>
          <b-form-select-option
            v-for="i in pastEventOptions"
            :value="i._id"
            :label="i.title"
            :key="i._id"
            >{{ i.title }}</b-form-select-option
          >
        </b-form-select> -->
        <p>Unique Name</p>
        <b-input
          placeholder="Enter unique name"
          class="mb-4"
          v-model="album.uniqueName"
          readonly
        />
        <p>Description</p>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Please input"
          class="mb-4"
          v-model="editAlbumDescription"
          @change="handleOnInputChange"
        >
        </el-input>

        <p>Upload Image</p>
        <el-upload
          multiple
          action="#"
          class="upload-demo"
          accept="image/*"
          list-type="picture-card"
          :file-list="images"
          :auto-upload="false"
          :on-remove="handleRemove"
          :on-change="handleOnChange"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            jpg/png files with a size less than 5MB
          </div>
        </el-upload>
        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 700px × 400px
        </div>
        <div class="flex justify-center mt-6">
          <b-button
            type="primary"
            native-type="submit"
            variant="primary"
            class="px-10 py-2 mx-1 flex items-center font-semibold"
            :disabled="this.submitDisabled"
            @click="handleSubmit"
          >
            Submit</b-button
          >
        </div>
      </div>
    </el-dialog>
    <div class="w-full flex justify-end">
      <b-button
        type="primary"
        native-type="submit"
        variant="primary"
        class="px-2 py-2 mx-1 flex items-center font-semibold"
        @click="dialogVisible = true"
      >
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Edit</b-button
      >
    </div>
    <div class="lg:flex md:flex gap-6 mb-6 mt-3">
      <div class="lg:w-1/2 md:w-1/2 lg:mb-0 md:mb-0 mb-4">
        <p class="fsize18 sm-fsize16 mb-1">{{ album.eventName.title }}</p>
        <p class="fsize18 sm-fsize16 lg:leading-6 md:leading-6 leading-5">
          {{ album.albumDescription }}
        </p>
      </div>
      <div class="lg:w-1/2 md:w-1/2">
        <img
          v-if="album.images.length === 0"
          src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
          alt="img"
          class="w-full lg:h-96 md:h-72 h-64 rounded-lg object-contain"
        />
        <img
          v-else
          :src="`${$imageURL}/${imageToDisplay}`"
          alt="img"
          class="w-full lg:h-96 md:h-72 h-64 rounded-lg object-contain"
        />
      </div>
    </div>

    <div>
      <swiper class="swiper" :options="swiperOptions">
        <!-- v-for="(item, index) in 6" :key="index" -->
        <div v-if="images.length == 0">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </div>
        <template v-else>
          <swiper-slide v-for="image in images" :key="image">
            <div class="relative">
              <img
                @click="switchImage(image)"
                :src="`${$imageURL}/${image}`"
                alt="img"
                class="w-full h-36 rounded-lg cursor-pointer"
              />
              <feather-icon
                icon="XIcon"
                class="mr-1 absl top-0 right-0 pr-2 pt-2 clr4F0A4B"
                @click="handleRemoveImage(image)"
              ></feather-icon>
            </div>
          </swiper-slide>
        </template>
        <!-- <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide> -->
        <div class="swiper-button-prev gallery" slot="button-prev"></div>
        <div class="swiper-button-next gallery" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          856: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
        // autoplay: {
        //   delay: 4000,
        //   disableOnInteraction: false,
        // },
      },
      editModal: false,
      submitDisabled: true,
      dialogVisible: false,
      album: {},
      editAlbumName: "",
      editAlbumDescription: "",
      images: [],
      fileList: [],
      imageToDisplay: "",
    };
  },
  computed: {
    ...mapState("mainAboutUs", { banner: "banner" }),
  },
  methods: {
    switchImage(e) {
      this.imageToDisplay = e;
    },
    getUrl(data) {
      return `${this.$imageURL}/${data}`;
    },
    async getAlbumData(galleryId) {
      const { data } = await this.$store.dispatch(
        "gallery/getAlbumById",
        galleryId
      );
      return data.album;
    },
    async init() {
      const galleryId = this.$route.params;
      this.album = await this.getAlbumData(galleryId);
      this.editAlbumName = this.album.albumName;
      this.imageToDisplay = this.album.images[0];
      this.editAlbumDescription = this.album.albumDescription;
      this.images = this.album.images;
      const result = [];
      this.images.forEach((image) => {
        result.push(`${$imageURL}/${image}`);
      });
      // console.log("result : ", result);
      this.images = result;
    },
    handleRemove(file, fileList) {
      fileList.length === 0
        ? (this.submitDisabled = true)
        : (this.submitDisabled = false);
      this.fileList = _.difference(fileList, [file]);
      // console.log("file list : ", this.fileList);
    },
    async handleRemoveImage(image) {
      this.$swal
        .fire({
          text: "Are you sure you want to remove the image?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#830c81",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, remove it!",
          cancelButtonText: "No, cancel",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const { id } = this.$route.params;
            let data = {};
            if (id) Object.assign(data, { id: id });
            if (image) Object.assign(data, { imageUrl: image });
            let loader = this.$loading();
            try {
              // console.log("remove image...", data);
              const albumData = await this.$store.dispatch(
                "gallery/removeImage",
                data
              );
              if (albumData.code == 200) {
                this.dialogVisible = false;
                this.$swal.fire({
                  text: "Image Removed Successfully",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
                loader.close();
                const galleryId = this.$route.params;
                this.album = await this.getAlbumData(galleryId);
                this.images = this.album.images;
              }
            } catch (error) {
              if (error) {
                loader.close();
                console.log(error);
              }
            }
          }
        });
    },
    async getImageMetadata(imageUrl) {
      let raw = await fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const file = new File([blob], "media", { type: blob.type });
          return file;
        })
        .catch((error) => {
          console.error("Error fetching the image:", error);
        });
      return raw;
    },
    handleOnInputChange() {
      if (
        this.editAlbumName !== this.album.albumName ||
        this.editAlbumDescription !== this.album.albumDescription
      ) {
        this.submitDisabled = false;
      } else {
        this.submitDisabled = true;
      }
    },
    handleOnChange(file, fileList) {
      fileList.length === 0
        ? (this.submitDisabled = true)
        : (this.submitDisabled = false);
      let mByte = 5 * 1048576;
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        fileList.pop();
        return;
      } else {
        this.fileList.push(file.raw);
        this.fileList = _.uniq(this.fileList, "uid");
        //console.log("unique filelist", this.fileList);
        // this.fileList = fileList.push(file);
        // console.log("change file list  :", this.fileList);
      }
    },
    async handleSubmit() {
      let data = new FormData();
      const { id } = this.$route.params;
      if (id) data.append("id", id);
      if (this.editAlbumName !== this.album.albumName)
        data.append("albumName", this.editAlbumName);
      if (this.editAlbumDescription !== this.album.albumDescription)
        data.append("albumDescription", this.editAlbumDescription);
      if (this.fileList && this.fileList.length !== 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          data.append("files", this.fileList[i]);
        }
      }
      let loader = this.$loading();
      try {
        const editedGalleryData = await this.$store.dispatch(
          "gallery/editAlbumData",
          data
        );
        if (editedGalleryData.code == 200) {
          this.dialogVisible = false;
          this.$swal.fire({
            text: "Gallery Updated Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
          const galleryId = this.$route.params;
          this.album = await this.getAlbumData(galleryId);
          this.images = this.album.images;
        }
      } catch (error) {
        if (error) {
          loader.close();
          console.log(error);
        }
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("mainAboutUs/getall_banner");
      this.init();
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
<style>
.gallery.swiper-button-next,
.swiper-button-prev {
  height: 24px !important;
  top: 55% !important;
}
</style>
